// extracted by mini-css-extract-plugin
export default {"selectedContainer":"NotificationRow_selectedContainer__yA38J","container":"NotificationRow_container__Noce0"};